// extracted by mini-css-extract-plugin
export var modalFooter = "_qq-0";